<template>
<div>
    <v-card>
        <v-card-title v-html="header">
        </v-card-title>

        <v-card-text :class="$style.vCard">
            <v-form v-model="valid_form" ref="form">
                <div :class="$style.questions" v-html="body"/>
                <div :class="$style.subtext" v-html="subtext"/>

                <div v-for="group in question.config.groups" :key="'group_'+group.id">
                    <div v-html="group.label[$language()]"></div>
                    <div>
                        <template v-for="input in group.inputs">
                            <div :key="'group_'+group.id+'input_'+input.id">
                                <h3 v-html="input.label[$language()]"></h3>
                                <v-date-picker 
                                style="border: 1px solid #eaeaea;"
                                    v-model="value[group.id][input.id]" 
                                    :class="$style.Calendar"
                                    :landscape="$vuetify.breakpoint.smAndUp"
                                    full-width
                                    :disabled="disabled[group.id][input.id]"
                                    :locale="locale"
                                    :allowed-dates="allowed_dates"
                                />
                                <!-- <v-btn v-if="value[group.id][input.id]!=null" @click="controller.clear(group.id,input.id)">Clear</v-btn> -->
                                <v-text-field 
                                    v-show="enableOther[group.id][input.id]" 
                                    :key="'group_'+group.id+'input_'+input.id+'_other'" 
                                    :autofocus="true" 
                                    :disabled="!enableOther[group.id][input.id]" 
                                    @keyup="other[group.id][input.id] ? other[group.id][input.id] = other[group.id][input.id].trimStart() : other[group.id][input.id]"
                                    v-model="other[group.id][input.id]" 
                                    >
                                    <template v-slot:label>
                                        <str index='survey > label please_specify' />
                                    </template>
                                </v-text-field>
                            </div>
                        </template>
                    </div>
                </div>
            </v-form>
        </v-card-text>

        <v-card-text v-html="footer">
        </v-card-text>
    </v-card>
</div>
</template>

<script>
const controller = require("./controllers/datePicker.js").default;
const module_generator = require("./controllers/module_generator.js").default;

var module_config = module_generator('date-question',controller);
module_config.methods.allowed_dates = function(val){
    var allow_dates = this.question.config.type_modifer.DatePicker.allow_dates;
    if(allow_dates){
        return allow_dates(val); 
    }else{
        return true;
    }
}
module_config.computed.locale = function(){
    return this.$language();
}
export default module_config
</script>

<style module>

.vCard {
    padding: 19px 140px;
    width: 100%;
    margin-bottom: 0px;
}

.Calendar {
    width:600px;
}
.questions {
    font-size:18px;
    margin-bottom: 15px;
    color:black;
}

.question{
    border: 1px solid slategray;
    border-radius: 3px;
    margin: 25px;
    padding: 15px;
}

.subtext{
    font-size: 1em;
}

@media only screen and (max-width: 1240px) {
    .vCard {
        padding: 0 100px;
    }
}

@media only screen and (max-width: 1145px) {
    .vCard {
        padding: 0 80px;
    }
}

@media only screen and (max-width: 1105px) {
    .vCard {
        padding: 0 30px;
    }
}

@media only screen and (max-width: 1000px) {
    .vCard {
        padding: 0 10px;
    }
}

@media only screen and (max-width: 980px) {

.questions {
    width: 95%;
}

.vCard {
    margin: 0px !important;
    width: 100%;
    padding: 0px 10px;
}

.Calendar {
    width:100% !important;
}
}
</style>

